import { createContext } from 'react';

import type { RegionSeasonContextType } from './types';

export const RegionSeasonContext = createContext<
  RegionSeasonContextType | undefined
>(undefined);
